import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar, showErrorSnackbar } from "../../redux/slices/snackbar";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  CardHeader,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { spacing } from "@mui/system";
import { useForm, FormProvider } from "react-hook-form";

import ComplaintButton from "../../components/ComplaintButton";
import useComplaint from "../../hooks/useComplaint";
import ComplaintFields from "./components/ComplaintFields";
import useAuth from "../../hooks/useAuth";
import { use } from "i18next";
// import AddComplaintTypeFields from "./components/ComplaintTypeFields";
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const initialValues = {
  selectedUser: null,
  complaintType: null,
  category: "",
  employee: null,
  priority: "LOW",
  complaintDetails: "",
  area: "",
};

const validationSchema = Yup.object().shape({
  selectedUser: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required("User is required"),
  complaintType: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required("Issue type is required"),
  category: Yup.string().required("Required"),
  priority: Yup.string().required("Required"),
  complaintDetails: Yup.string().required("Required"),
});

function AddComplaint() {
  const { user: loginUserDetails } = useAuth();
  const [type, setType] = useState("single");
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const { state } = useLocation();
  console.log(state, "location");

  const [selectedComplaint, setSelectedComplaint] = useState(null);

  const { addComplaint, hasError, errorMessage, isSubmitting, resetExistingComplaints } =
    useComplaint();
  const navigate = useNavigate();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = methods;

  React.useEffect(() => {
    console.log(state, "statestate");
    if (
      state != null &&
      Object.keys(state).length !== 0 &&
      state.userName != undefined &&
      state.radUserId != undefined
    ) {
      const initialValues = {
        userName: {
          label: state?.userName,
          value: state?.radUserId,
        },
      };
      reset(initialValues);
    }
  }, [state]);

  useEffect(() => {
    if (selectedComplaint != null) {
      setValue("category", selectedComplaint?.complaintCategory);
      setValue("employee", {
        label: selectedComplaint?.employeeName,
        value: selectedComplaint?.employeeId,
      });
      setValue("priority", selectedComplaint.priority);
    }
  }, [selectedComplaint]);

  const onSubmit = async (data) => {
    try {
      let payload = {};

      payload["complaintDetails"] = data.complaintDetails;
      payload["priority"] = data.priority;

      payload["radUser"] = {
        radUserId: data.selectedUser.value,
        userName: data.selectedUser.label,
      };
      if (data.employee !== null) {
        payload["employee"] = {
          employeeId: data.employee.value,
          employeeName: data.employee.label,
        };
      }
      payload["complaintType"] = {
        complaintTypeId: data.complaintType.value,
        complaintTypeName: data.complaintType.label,
      };
      payload["complaintCategory"] = data.category;
      payload["area"] = data.area;
      payload["existingComplaintId"] = selectedComplaint?.complaintId;

      console.log(payload, "complaint data fff");

      await addComplaint(payload);
      dispatch(showSuccessSnackbar("Complaint added successfully!"));
      resetValues();
    } catch (err) {
      console.log(err, "errddddd");
      dispatch(showErrorSnackbar("Failed to add complaint "));
    }
  };

  const cancelBtn = () => {
    if (state != null && Object.keys(state).length != 0) {
      navigate(state?.backTo);
    } else {
      navigate("/complaints/list");
    }
  };

  const resetValues = () => {
    reset();
    resetExistingComplaints();
    setSelectedComplaint(null);
    if (loginUserDetails && loginUserDetails.businessType == "USER") {
      setValue("selectedUser", {
        label: loginUserDetails.username,
        value: loginUserDetails.radUserId,
      });
    }
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Complaint</Typography>
        <Typography>Add</Typography>
      </Breadcrumbs>
    );
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("add_complaint")} subheader={breadCrump()} />
          <CardContent>
            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <ComplaintFields
                  fields={validationSchema.fields}
                  selectedComplaint={selectedComplaint}
                  setSelectedComplaint={setSelectedComplaint}
                />
                <br></br>
                <ComplaintButton
                  cancelBtn={cancelBtn}
                  resetForm={resetValues}
                  disabledMapButton={!selectedComplaint}
                  disabledCreateButton={selectedComplaint}
                />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default AddComplaint;
